import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  // Check if user is authenticated by looking for the auth token
  const isAuthenticated = () => {
    const token = localStorage.getItem("authToken");
    return token !== null && token !== undefined && token !== "";
  };

  // If user is not authenticated, redirect to login page
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  // If user is authenticated, render the protected components
  return children;
};

export default ProtectedRoute;
